export default {"src":"/_next/static/media/SEK.d1633124.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};